import React, { useState } from 'react';
import { Battery, Heart, Brain, Activity, Timer } from 'lucide-react';
import { RecoveryBreakdown } from '../recovery/RecoveryBreakdown';
import { RecoveryInsights } from '../recovery/RecoveryInsights';
import { RecoveryTrends } from '../recovery/RecoveryTrends';
import { RecoveryKnowledge } from '../recovery/RecoveryKnowledge';
import { RecoveryMetricCard } from '../recovery/RecoveryMetricCard';
import { HealthMetrics } from '../../types/health';

interface RecoveryTabProps {
  metrics: HealthMetrics;
  onClose: () => void;
}

export function RecoveryTab({ metrics, onClose }: RecoveryTabProps) {
  const [selectedTimeframe, setSelectedTimeframe] = useState<'24h' | '7d' | '30d'>('24h');

  return (
    <div className="space-y-6">
      {/* Recovery Metrics Overview */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <RecoveryMetricCard
          title="Recovery Score"
          value={metrics.recovery}
          unit="%"
          icon={<Battery className="w-4 h-4" />}
          status={metrics.recovery > 70 ? 'success' : 'warning'}
          comparison="+5% vs yesterday"
        />
        <RecoveryMetricCard
          title="HRV"
          value={metrics.hrv.current}
          unit="ms"
          icon={<Heart className="w-4 h-4" />}
          status={metrics.hrv.current > metrics.hrv.yesterday ? 'success' : 'warning'}
          comparison={`${metrics.hrv.current - metrics.hrv.yesterday}ms vs yesterday`}
        />
        <RecoveryMetricCard
          title="Resting HR"
          value={62}
          unit="bpm"
          icon={<Activity className="w-4 h-4" />}
          status="success"
          comparison="-2 bpm vs baseline"
        />
        <RecoveryMetricCard
          title="Recovery Time"
          value="6:45"
          unit="hours"
          icon={<Timer className="w-4 h-4" />}
          status="success"
          comparison="Optimal range"
        />
      </div>

      {/* Recovery Score Trends */}
      <RecoveryTrends 
        metrics={metrics}
        timeframe={selectedTimeframe}
        onTimeframeChange={setSelectedTimeframe}
      />

      {/* Recovery Breakdown */}
      <RecoveryBreakdown metrics={metrics} />

      {/* Recovery Insights */}
      <RecoveryInsights metrics={metrics} />

      {/* Knowledge Center */}
      <RecoveryKnowledge />
    </div>
  );
}